import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate, useNavigate } from 'react-router-dom';
import JobFormPreview from '../components/Jobs/JobFormPreview';

const CreateJobPage: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  // Show loading state while auth is being checked
  if (isLoading) {
    return (
      <div className="create-job-container">
        <div className="loading">Kraunama...</div>
      </div>
    );
  }

  // Redirect if not authenticated or not an employer
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (user?.user_type !== 'employer') {
    return <Navigate to="/" replace />;
  }

  const handleJobFormSuccess = () => {
    navigate('/jobs?mode=employer');
  };

  const handleJobFormCancel = () => {
    navigate('/jobs?mode=employer');
  };

  return (
    <div className="create-job-page">
      <JobFormPreview onSuccess={handleJobFormSuccess} onCancel={handleJobFormCancel} />
    </div>
  );
};

export default CreateJobPage;
